module.exports = __webpack_public_path__ + "static/media/2024.08d10cd1.png";